import React, { Component } from 'react'
import { Button } from '@drifthq/tide-core'
import cx from 'classnames'

import CopyToClipboard from 'react-copy-to-clipboard'

import './style.css'

export default class Snippet extends Component {
  state = {
    copied: false
  }

  onCopy = () => {
    this.setState({ copied: true })
    setTimeout(() => {
      this.setState({ copied: false })
    }, 1000)
  }

  render() {
    const { snippet, className } = this.props
    const { copied } = this.state
    return (
      <CopyToClipboard text={snippet} onCopy={this.onCopy}>
        <div className="touchless-install-snippet-card-container">
          <pre className={cx("touchless-install-snippet-card-snippet", className)}>
            {snippet}
          </pre>
          <Button
            className="touchless-install-snippet-copy-button"
            type="tertiary"
          >
            {copied ? 'Copied!' : 'Copy Code'}
          </Button>
        </div>
      </CopyToClipboard>
    )
  }
}



// WEBPACK FOOTER //
// ./src/layouts/Snippet/index.js